export default [
    {
        path: '',
        component: () => import('@/layouts/Base.vue'),
        children: [
            {
                path: '/',
                name: 'building_overview',
                component: () => import('@/pages/ControllerOverview.vue'),
            },
            {
                path: 'controller/:id/rooms',
                name: 'rooms',
                component: () => import('@/pages/Rooms.vue'),
            },
            {
                path: 'controller/:id/rooms/:roomId',
                name: 'roomDetails',
                component: () => import('@/pages/RoomDetails.vue'),
            },
        ],
    },
    {
        path: '*',
        component: () => import('@/pages/errors/NotFound.vue'),
        name: 'notFound',
    },
];
